import React, { useMemo, useCallback } from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { Form, Item, RequiredRule } from 'devextreme-react/form';
import useHandleTaskRates from '../../../Hooks/useHandleData/useHandleTaskRates';

const EditPopup = ({ popup, setPopup, formData, setFormData }) => {

    const { handlePutTaskRate } = useHandleTaskRates();

    const editTaxRate = useCallback(async () => {
        let isDataGood = await handlePutTaskRate(formData);

        if (isDataGood) {
            setPopup(false);
            setFormData({});
        }
    }, [formData, handlePutTaskRate, setFormData, setPopup]);

    const submitOptions = useMemo(() => {
        return {
            stylingMode: 'contained',
            text: "Send",
            onClick: () => { editTaxRate(); }
        }
    }, [editTaxRate]);

    const cancelOptions = useMemo(() => {
        return {
            stylingMode: "outlined",
            text: 'cancel',
            onClick: () => { setPopup(false); }
        }
    }, [setPopup]);

    return (
        <Popup
            visible={popup}
            width="50%"
            height="auto"
            hideOnOutsideClick={true}
            onHiding={() => setPopup(false)}
            title="Edit Task Rate"
        >
            <Form
                formData={formData}
                showValidationSummary={true}>
                <Item
                    dataField="year"
                    editorType="dxNumberBox">
                </Item>
                <Item
                    dataField="industry"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
                <Item
                    dataField="federal"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
                <Item
                    dataField="overhead"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
            </Form>
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={cancelOptions}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={submitOptions}
            />
        </Popup>
    );
};

export default EditPopup;
